import styled from 'styled-components';

import { Form } from '@unform/web';

import { breakpoints } from '~/styles/tools/breakpoints';

export const SaveOperatorModalContent = styled(Form)`
  display: flex;

  width: 100%;
  align-items: start;
  gap: 2.4rem;
  @media (max-width: ${breakpoints.medium}) {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;

export const SaveOperatorBoxImage = styled.label`
  background: #ddd;
  width: 206px;
  height: 206px;
  border: 4px solid ${({ theme }) => theme.colors.primary};
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;

  > img {
    width: 69px;
    height: 60px;
  }

  &:hover {
    cursor: pointer;
  }
`;

export const SaveOperatorModalInputBox = styled.div`
  width: 100%;
  margin-top: 10px;
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 2rem;
  width: 100%;
  justify-content: center;
`;

export const Fieldset = styled.fieldset`
  margin: 0 0 10px 0;
  text-align: left;
  border: 0;
  padding: 0;
`;

export const Legend = styled.legend`
  color: #555;
  margin-bottom: 8px;
  font-size: 15px;
`;

export const RadioGroup = styled.div`
  display: flex;
  align-items: start;
  gap: 8px;
  flex-direction: column;
`;

export const RadioLabel = styled.label`
  display: flex;
  align-items: center;
  margin-right: 16px;
  cursor: pointer;
  color: #868686;
  font-size: 16px;
`;

export const RadioInput = styled.input`
  margin-right: 4px;
  color: #868686;
  font-size: 16px;
`;
